module.exports = __webpack_public_path__ + "static/media/ski-jump.6c9f60ae.svg";